import React, {useState} from "react";
import {programsService} from "../../../../services/programsService/programsService";
import {Modal} from "react-bootstrap";
import ModalClose from "../../../../assets/modal_close.png";
import {FaLinkedinIn} from "react-icons/fa";
import {LiaRocketchat} from "react-icons/lia";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import CommentLoader from "../../../../components/common/CommentLoader";

const ShareNextStepModal = ({ programId, nextStepId, onClose, showModal }) => {
    const [isSharing, setIsSharing] = useState(false);
    const [newDiscussion, setNewDiscussion] = useState(false);
    const navigate = useNavigate();

    const handleClose = () => {
        onClose();
    };

    const shareToCommunity = async () => {
        setIsSharing(true);
        try {
            const discussion = await programsService.shareNextStepOnCommunity(programId, nextStepId);
            setNewDiscussion(discussion.data);
            toast.success('The next steps was successfully shared.');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to share next step');
        } finally {
            setIsSharing(false);
        }
    }

    const shareToLinkedin = async () => {
        setIsSharing(true);
        try {
            const { data } = await programsService.shareNextStepOnLinkedin(programId, nextStepId);
            window.open(data.share_url, '_blank');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to share next step');
        } finally {
            setIsSharing(false);
        }
    }

    if (!showModal) {
        return <></>;
    }

    return (
        <>
            <Modal onHide={handleClose} centered className="resources-file-uploaded-popup" show="true" size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className="modal-header m-0">
                    <div className="question">Would you like to share your answer?</div>
                    <div className="modal-close" onClick={() => handleClose()}>
                        <img src={ModalClose} alt="Close" />
                    </div>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "-webkit-fill-available", overflowY: "auto" }}>
                    {isSharing ? <CommentLoader />
                        : <div className="row w-ful justify-content-center align-center px-3">
                            {newDiscussion ?
                                <div className="d-flex justify-content-start flex-wrap my-2">
                                    <div className="d-flex align-center">
                                        <LiaRocketchat
                                            className={`fs-6 mr-5`}
                                        />
                                        <div className="fs-6 lh-base">
                                            Click <span className="show-guidelines-button cursor-pointer fs-6 fs-lg" onClick={() => navigate(`/community/member-discussions/${newDiscussion.id}`)}>here</span> if you want to see your new community topic
                                        </div>
                                    </div>
                                </div>
                                :  <div className="d-flex justify-content-start flex-wrap my-2">
                                    <div className="share-certificate-icon share-badge__linkedin cursor-pointer d-flex align-center" onClick={shareToCommunity}>
                                        <LiaRocketchat
                                            className={`fs-6 mr-5`}
                                        />
                                        <div className="fs-6 lh-base">
                                            Share to discussion board
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="d-flex justify-content-start flex-wrap my-2">
                                <div className="share-certificate-icon share-badge__linkedin cursor-pointer d-flex align-center" onClick={shareToLinkedin}>
                                    <FaLinkedinIn
                                        className={`fs-6 mr-5`}
                                    />
                                    <div className="fs-6 lh-base">
                                        Share to Linkedin
                                    </div>
                                </div>
                            </div>
                        </div>}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ShareNextStepModal;